import script from "./MarketPromotionRibbon.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketPromotionRibbon.vue?vue&type=script&lang=ts&setup=true"

import "./MarketPromotionRibbon.vue?vue&type=style&index=0&id=a1202588&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1202588"]])

export default __exports__